<template>
	<div class="urban-regulation">
		<a @click.stop="toggle=!toggle" class="dashed">{{regulation.regulationFullName}}</a>		
			<div v-show="toggle">
				<div class="urban-kinds">
					<urban-ter-zone-usage-kinds name="Основные виды разрешенного использования:" :usage-kinds="regulation.primary" cls="urban-ter-zone-usage-kinds"></urban-ter-zone-usage-kinds>
					<urban-ter-zone-usage-kinds name="Условно разрешенные виды использования:" :usage-kinds="regulation.conditional" cls="urban-ter-zone-usage-kinds"></urban-ter-zone-usage-kinds>
					<urban-ter-zone-usage-kinds name="Вспомогательные виды разрешенного использования:" :usage-kinds="regulation.secondary" cls="urban-ter-zone-usage-kinds"></urban-ter-zone-usage-kinds>
				</div>
			</div>		
	</div>
</template>
<script>
	import UrbanTerZoneUsageKinds from "./UrbanTerZoneUsageKinds";

	export default {
		props: {
			regulation: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				toggle: true
			}
		},
		components: {
			UrbanTerZoneUsageKinds
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import '../../assets/sass/main.scss';

	.dashed {
		border-bottom: 1px dashed $cyan;
	}

	.urban-regulation:not(:first-child) {
		margin-top: 1rem;
	}
</style>
